import { render, staticRenderFns } from "./QuickShipperUnitPricesModal.vue?vue&type=template&id=37e704cf&scoped=true"
import script from "./QuickShipperUnitPricesModal.vue?vue&type=script&lang=js"
export * from "./QuickShipperUnitPricesModal.vue?vue&type=script&lang=js"
import style0 from "./QuickShipperUnitPricesModal.vue?vue&type=style&index=0&id=37e704cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../Desktop/Trabajo/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e704cf",
  null
  
)

export default component.exports